export const BACKWARD = 'backward';
export const FORWARD = 'forward';
export const isRollingDateDirection = direction => {
  return direction === BACKWARD || direction === FORWARD;
};